export const LAYERS_FETCHING_ERROR_PREFIX = 'Failed to fetch layers';
